import styled from 'styled-components';

// ✅ Usar sistema de temas - siguiendo patrón MainButton
export const Container = styled.div`
  width: 100%;
`;

export const BudgetItemManagementSection = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  background: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS */
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  width: 100%;
`;
